/* Pensualizei — ícone de conta do header. Lê window.PS_ACCOUNT_URL (definido via Liquid no meta-tags): logado -> /account (pedidos); deslogado -> storefront_login_url (login que volta pra página onde estava). Mira só o ícone de conta (svg viewBox 0 0 21 21). Reversível: remover o include no meta-tags. */
(function(){
  function fix(){
    var url = window.PS_ACCOUNT_URL;
    if(!url) return;
    var scope = document.querySelector('.header-wrapper') || document.querySelector('.section-header') || document.querySelector('header') || document;
    if(!scope) return;
    var links = scope.querySelectorAll('a[href="#"], a[href="/#"], a[href="/account"], a[href^="/customer_authentication/login"]');
    links.forEach(function(a){
      if(a.querySelector('svg[viewBox="0 0 21 21"]')){
        a.setAttribute('href', url);
        a.setAttribute('aria-label','Conta');
      }
    });
  }
  if(document.readyState !== 'loading') fix();
  else document.addEventListener('DOMContentLoaded', fix);
})();
